// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3062) return "static/chunks/walletconnect-5c8d022716e0a680.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"137":"0f2491ed1f415e2d","584":"31d7a2ffb83fbb03","2520":"ec38ea60ac63b284","6145":"75d7c20cb13e31ed","8986":"736f04019c66de58","9220":"3ca359a12e2b5c34","9341":"2879f863fa2d3e28","9518":"4087831df4ac6747"}[chunkId] + ".js";
};